import { TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import '../../components/app/common.scss';
import Checkbox from './Checkbox';


function DatePicker({ onChange, placeholder = '', name, parent = undefined, value = null, optionalName = '', label = '' }) {

  const handleDateChange = (e) => {
    if (parent) {
      parent.value = e?.format("MM/DD/YYYY");
      parent[optionalName] = false;
    }
    onChange(e);
  }
  const handleCheckboxChange = (e) => {
    if (parent) {
      parent[optionalName] = e.target.checked;
      parent.value = null;
    }
    onChange(e);
    value = null;
  }
  return (
    <div className='custom-date-picker'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          value={value || null}
          onChange={handleDateChange}
          renderInput={(params) => {
            return <TextField {...params}></TextField>
          }
          }
        />
        </LocalizationProvider>
      {optionalName && <Checkbox name={optionalName} label={label} checked={parent[optionalName]} onChange={handleCheckboxChange} />}
      <input style={{height: '0', color: 'transparent', display: 'block', border: '0', outline:'none'}} 
      required value={parent[optionalName] || value} onChange={() => {}}></input>
    </div>
  );
}

export default DatePicker;